import type { LiveInputs } from '../types'

import LiveInputsClass from '../handlers/live_inputs_class'
import { makePageSingleton } from '@app/adapters/singleton/page'

class LiveInputsService {
  #instances: Array<LiveInputs> = []

  get instance(): LiveInputs | null {
    if (this.#instances.length > 0) {
      return this.#instances[this.#instances.length - 1]
    }

    // Try to fallback to the existing document and rebuild
    this.buildInstances(document)

    if (this.#instances.length > 0) {
      return this.#instances[this.#instances.length - 1]
    }
    return null
  }

  buildInstances = (doc: Document | Element): void => {
    doc
      .querySelectorAll("[data-behaviour='live-inputs']")
      .forEach((el: Element) => {
        const instance = new LiveInputsClass(el, false)
        this.#instances.push(instance)
      })

    doc
      .querySelectorAll("[data-behaviour='locked-live-inputs']")
      .forEach((el: Element) => {
        const instance = new LiveInputsClass(el, true)
        this.#instances.push(instance)
      })
  }

  // Gets called automatically when the page changes
  teardown = (): void => {
    this.#instances.forEach((instance) => {
      instance.teardown()
    })

    this.#instances = []
  }
}

export default makePageSingleton(() => new LiveInputsService())
